import { render, staticRenderFns } from "./ExpertTermsRemindersFilter.vue?vue&type=template&id=2308e4f2&scoped=true"
import script from "./ExpertTermsRemindersFilter.vue?vue&type=script&lang=js"
export * from "./ExpertTermsRemindersFilter.vue?vue&type=script&lang=js"
import style0 from "./ExpertTermsRemindersFilter.vue?vue&type=style&index=0&id=2308e4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308e4f2",
  null
  
)

export default component.exports